import React, { useContext, useState, useEffect, Fragment } from "react";

import AlertContext from "../../context/alert/alertContext";
import AuthContext from "../../context/auth/authContext";

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import { makeStyles } from "@material-ui/core/styles";
import PersonIcon from "@material-ui/icons/Person";


const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: '100%',
      maxWidth: 400,
    },
  },
  input: {
    display: "none",
  },
}));

const Register = (props) => {
  const classes = useStyles();

  const alertContext = useContext(AlertContext);
  const authContext = useContext(AuthContext);

  const { setAlert } = alertContext;
  const { register, message, clearAuthMessages, isAuthenticated } = authContext;


  // Check if already logged in — only on mount.
  useEffect(() => {
    if (authContext.token) {
      authContext.loadUser();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      props.history.push("/destinations");
    }
    if (message) {
      setAlert(message, "error");
      clearAuthMessages();
    }
    // eslint-disable-next-line
  }, [message, isAuthenticated, props.history]);

  const [user, setUser] = useState({
    name: "",
    first_name: "",
    last_name: "",
    user_id: "",
    password: "",
    password2: "",
    avatar: "",
  });

  const [file, setFile] = useState(null);

  const onSelectFile = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.files[0],
    });
    setFile(e.target.files[0]);
  };

  const { name, first_name, last_name, user_id, password, password2, avatar } = user;

  const onChange = (e) => setUser({ ...user, [e.target.name]: e.target.value });

  const userIdPattern = /^[a-zA-Z0-9_-]+$/;

  const onSubmit = (e) => {
    e.preventDefault();
    if (user_id === "" || password === "") {
      setAlert("Please enter User ID and password", "error");
      return;
    }
    if (user_id.length < 3 || user_id.length > 20) {
      setAlert("User ID must be between 3 and 20 characters", "error");
      return;
    }
    if (!userIdPattern.test(user_id)) {
      setAlert("User ID can only contain letters, digits, underscores, and hyphens", "error");
      return;
    }
    if (password.length < 8) {
      setAlert("Password must be at least 8 characters", "error");
      return;
    }
    if (password === user_id) {
      setAlert("Password must not be the same as your User ID", "error");
      return;
    }
    if (password !== password2) {
      setAlert("Passwords do not match", "error");
      return;
    }
    register({
      name,
      first_name,
      last_name,
      user_id,
      password,
      avatar,
    });
  };
  return (
    <Fragment>
      <br />
      <br />
      <Grid container>
        <Grid size={{ xs: 1, sm: 2, lg: 3 }}></Grid>
        <Grid size={{ xs: 10, sm: 8, lg: 6 }}>
          <h1>Register</h1>
          <form
            className={classes.root}
            noValidate
            autoComplete="off"
            onSubmit={onSubmit}
          >
            <div>
              <TextField
                required
                id="standard-required-user-id"
                label="User ID"
                name="user_id"
                value={user_id}
                onChange={onChange}
              />
            </div>
            <div>
              <TextField
                id="standard-display-name"
                label="Display Name"
                name="name"
                value={name}
                onChange={onChange}
                helperText="Optional — defaults to your User ID"
              />
            </div>
            <div>
              <TextField
                id="standard-first-name"
                label="First Name"
                name="first_name"
                value={first_name}
                onChange={onChange}
              />
              <TextField
                id="standard-last-name"
                label="Last Name"
                name="last_name"
                value={last_name}
                onChange={onChange}
              />
            </div>
            <div>
              <TextField
                required
                id="standard-password-input"
                label="Password"
                type="password"
                autoComplete="current-password"
                name="password"
                value={password}
                onChange={onChange}
                fullWidth
              />
            </div>
            <div>
              <TextField
                required
                id="standard-password-input-confirm"
                label="Confirm Password"
                type="password"
                autoComplete="current-password"
                name="password2"
                value={password2}
                onChange={onChange}
                fullWidth
              />
            </div>
            <div>
              <input
                accept="image/*"
                className={classes.input}
                id="icon-button-file"
                type="file"
                name="avatar"
                onChange={onSelectFile}
              />
              <label htmlFor="icon-button-file">
                <IconButton
                  color="primary"
                  aria-label="upload picture"
                  component="span"
                >
                  <Avatar src={file ? `${URL.createObjectURL(file)}` : ``}>
                    <PersonIcon />
                  </Avatar>
                  {file ? (
                    <Typography variant="h6"> {file.name}</Typography>
                  ) : (
                    <Typography variant="h6">
                      Upload your profile picture
                    </Typography>
                  )}
                </IconButton>
              </label>
            </div>
            <br />
            <div>
              <Button
                type="submit"
                value="Register"
                variant="contained"
                color="primary"
                style={{ background: "#03a9f4" }}
              >
                Register
              </Button>
            </div>
          </form>
        </Grid>
        <Grid size={{ xs: 1, sm: 2, lg: 3 }}></Grid>
      </Grid>
    </Fragment>
  );
};

export default Register;
